import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import OnboardingPage from './components/OnboardingPage';
import AdminLoginPage from './components/AdminLoginPage';
import AdminPage from './components/AdminPage';
import ResetPasswordPage from './components/ResetPasswordPage'; // Import the ResetPasswordPage
import QuestionsPage from './components/QuestionsPage';
import GlobalStyles from './styles/GlobalStyles';
import { hasAdminSession } from './services/session';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return hasAdminSession();
  });

  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/questions" element={<QuestionsPage />} />
        <Route path="/admin-login" element={<AdminLoginPage setIsAuthenticated={setIsAuthenticated} />} />
        
        {/* Protect the /admin route */}
        <Route path="/admin" element={isAuthenticated ? <AdminPage /> : <Navigate to="/admin-login" />} />

        {/* Add the Reset Password route */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/" element={<LoginPage />} />
        {/* Redirect all undefined routes to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
